import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ContractSlice } from '@classes/contract-slice';
import { ContractSliceDetail } from '@classes/contract-slice-detail';
import { ContractSliceService } from 'app/core/services/contract-slice.service';
import { IndexService } from 'app/core/services/index.service';
import { UiService } from 'app/core/services/ui.service';

@Component({
  selector: 'app-contract-slice',
  templateUrl: './contract-slice.component.html',
  styleUrls: ['./contract-slice.component.scss']
})
export class ContractSliceComponent implements OnInit {

  contractSliceForm: FormGroup;
  indexPrice = 0;

  constructor(
    private formBuilder: FormBuilder,
    private uiService: UiService,
    private contractSliceService: ContractSliceService,
    public dialogRef: MatDialogRef<ContractSliceComponent>,
    private indexService: IndexService,
    @Inject(MAT_DIALOG_DATA) public data?: ContractSliceDetail
  ) { }

  ngOnInit() {
    this.initFormBuilder(this.data?.contractSlice);
  }

  private initFormBuilder(value?: ContractSlice) {
    var editMode = !(this.data?.isEditMode || this.data?.isCreationMode);
    const fb = this.formBuilder;
    this.contractSliceForm = fb.group({
      id: fb.control(value?.id),
      contractId: fb.control(value?.contractId || this.data?.contract?.id),
      price: fb.control({ value: value?.price, disabled: editMode }, [Validators.required]),
      tonnage: fb.control({ value: value?.tonnage, disabled: editMode }, [Validators.required]),
      isLastSlice: fb.control({ value: value?.isLastSlice, disabled: true }, [Validators.required]),
    });
    this.indexPrice = (value?.price || 1) * (this.indexService.currentCoef?.value || 1);
    this.contractSliceForm.controls.price.valueChanges.subscribe(value => {
      this.indexPrice = value * (this.indexService.currentCoef?.value || 1);
    })
  }
  onSubmit() {
    this.uiService.addRouteLoading();
    const contractSlice = new ContractSlice(
      this.contractSliceForm.value
    );
    this.contractSliceService.createOrUpdateContractSlice(contractSlice).subscribe(data => {
      this.uiService.removeRouteLoading();
      if (this.dialogRef) {
        this.dialogRef.close(true);
      }
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    });
  }
  onCancel() {
    this.dialogRef.close(false);
  }

  isRequiredField(field: string) {
    const form_field = <AbstractControl>this.contractSliceForm.get(field);
    if (!form_field.validator) {
      return false;
    }

    const validator = form_field.validator({} as AbstractControl);
    return (validator && validator.required);
  }
}
